import { en } from './en';
import { gu } from './gu';

export const currentLocale: 'en' | 'gu' =
  process.env.REACT_APP_LOCALE === 'en' ? 'en' : 'gu';

export const t = currentLocale === 'en' ? en : gu;
